
import React from 'react';
import { CERTIFICATIONS, Icons } from '../constants';

const TrustBar: React.FC = () => {
  return (
    <div className="bg-white border-y-2 border-accent/20 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-10 md:gap-x-24">
          {CERTIFICATIONS.map((cert, i) => (
            <div key={i} className="flex items-center gap-5 group">
              <div className="w-12 h-12 rounded-full bg-accent-light flex items-center justify-center group-hover:bg-accent transition-colors duration-500">
                <div className="text-primary scale-90">
                  <Icons.Shield />
                </div>
              </div>
              <div className="flex flex-col">
                <span className="text-[11px] font-bold text-primary uppercase tracking-[0.2em] mb-1">
                  {cert.name}
                </span>
                <span className="text-[9px] text-gray-400 uppercase tracking-widest font-medium opacity-80">
                  {cert.description}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustBar;
